export default __webpack_public_path__ + "static/media/white-rectangle-measure-icon.d63904bc.svg";